export default "__VITE_ASSET__ClihARGd__"